import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getOrgTermsContent } from '../../../content/utils.js';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import StepDetailsFormContainer from '../../../containers/portfolio/PortfolioFormContainers/StepDetailsFormContainer.jsx';

const EditPortfolioStepDetails = ({ portfolioId, slug }) => (
  <>
    <Helmet>
      <title>Edit {getOrgTermsContent('portfolio')} | ChangeSync</title>
    </Helmet>
    <StepDetailsFormContainer portfolioId={portfolioId} slug={slug} />
  </>
);

EditPortfolioStepDetails.getInitialProps = ({ query }) => ({
  portfolioId: Number(query.portfolioId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(EditPortfolioStepDetails));
